import { render, staticRenderFns } from "./CollectionTarBar.vue?vue&type=template&id=4077ca6e&scoped=true"
import script from "./CollectionTarBar.vue?vue&type=script&lang=js"
export * from "./CollectionTarBar.vue?vue&type=script&lang=js"
import style0 from "./CollectionTarBar.vue?vue&type=style&index=0&id=4077ca6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4077ca6e",
  null
  
)

export default component.exports